import TabsContainer from "../../Componant/Ui Kit/Tabs";

const Tabs = () => {
  return (
    <div className="page-body">
        <TabsContainer/>
    </div>
  )
};

export default Tabs;
